import { render } from "./ListSectionPage.vue?vue&type=template&id=1ab10ff6&scoped=true"
import script from "./ListSectionPage.vue?vue&type=script&lang=js"
export * from "./ListSectionPage.vue?vue&type=script&lang=js"

import "./ListSectionPage.vue?vue&type=style&index=0&id=1ab10ff6&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ab10ff6"]])

export default __exports__